import Drone from "../../images/drone.jpg";
import N8File from "../../files/NEURO8.pdf";
import FFace from "../../images/FemaleFace.webp";
import Results from "../../files/neuro8-fly-a-drone-results.pdf";
import Retreat1 from "../../images/retreat/home-section/1.png";
// import Retreat2 from "../../images/retreat/home-section/2.png";
// import Retreat3 from "../../images/retreat/home-section/3.png";
// import Retreat4 from "../../images/retreat/home-section/4.png";
// import Retreat5 from "../../images/retreat/home-section/5.png";
import Retreat6 from "../../images/retreat/home-section/6.png";
// import Retreat7 from "../../images/retreat/home-section/7.png";
import Retreat8 from "../../images/retreat/home-section/8.png";
import Retreat9 from "../../images/retreat/home-section/9.png";
import DroneUser from "../../images/retreat/home-section/user-1-results.jpg";
import DASS21 from "../../images/retreat/home-section/DASS21-survey-results.jpg";

export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "WHY",
  headline1: "TRAINING",
  description1: (<>
                  Advanced Leadership Retreats <br />
                  In house corporate training
                </>),
  headline2: "TRIALS",
  description2: (<>
                  Military Training <br />
                  Veteran Training
                </>),
  headline3: "TALKS",
  description3: (<>
                     Mission <span className="crossed-out">IM</span>POSSIBLE - ‘Fly a drone by thought alone’  <br />
                     The real cost of Cyber <br />
                     Neuro-leadership - A winning formula
                   </>),
  buttonLabel: "Learn More",
  imgStart: true,
  image: FFace,
  alt: "AI generated face of a lady with the right side as a AI robot",
  dark: true,
  primary: true,
  darkText: false,
  showButton: true,
  buttonToPDF: true,
  buttonLink: N8File,
  showTestimonialButton: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "WHAT",
  headline1: "“Fly A Drone By Thought Alone”",
  description1: "Here is an example of one of our ‘special projects’ in the Defence and Security sector: UltraNIMBUS enables the operator to ‘fly a drone by thought alone’. We showcased this at the UK Specialist Defence & Security Conference (SDSC-UK) in 2021 and were featured in Soldier magazine and various media channels including Bloomberg. The capability moved from TRL 4 - TRL 6 during a defence (defense) sector trial with a US military client and Ultra PCS Ltd Q3 2023.",
  description2: "If we can fly a drone by thought alone imagine what we can achieve with your people?",
  description3: "'Humans are more important than hardware' USSOCOM Special Forces Command Truth #1",
  buttonLabel: "Learn More - NIMBUS",
  buttonLabel2: "Download Results",
  imgStart: false,
  image: Drone,
  // OLD STYLE image: require("../images/ppt.svg").default,
  // backgroundImage: backgroundImage,
  alt: "ellen with headset on",
  dark: false,
  primary: false,
  darkText: true,
  showButton: true,
  showButton2: true,
  buttonToPDF: false,
  buttonLink: "tech",
  buttonToPDF2: true,
  buttonLink2: Results,
  showTestimonialButton: false,
};

export const homeObjThree = {
  id: "retreat",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "RETREATS",
  headline1: "Advanced Leadership",
  description1: (
    <>
      These are not retreats but an ‘advance’. We have created an immersive, highly engaged learning experience combined with the latest research in neuroscience and data driven analytics. Selecting exceptional locations worldwide delivering this unique programme, with proven results, to leaders operating in a world of fast paced and complex change. We demonstrate that performance is directly linked to wellbeing. (*Fly a drone by thought alone trial results).
    </>
  ),
  headline2: "What are the benefits:",
  description2: (
    <ul>
      <li>Enhanced decision accuracy +51.4%</li>
      <li>Improved resilience and recovery -55%</li>
      <li>Sustained attention +53%</li>
    </ul>
  ),
  headline3: "What is the science & technology:",
  description3: (
    <>
      Neuroscience, BCI, EEG, HRV and DASS21 surveys
    </>
  ),
  imgStart: false,
  images: [Retreat1, Retreat6, Retreat8, Retreat9, DroneUser, DASS21],
  alt: "people meditating at retreat",
  dark: false,
  primary: false,
  darkText: true,
  buttonLabel: "Explore Retreats",
  buttonLabel2: "View DASS21 Survey",
  showButton: true,
  showButton2: true,
  showButton3: false,
  buttonToPDF: false,
  buttonLink: "/retreats",
  buttonToPDF2: true,
  buttonLink2:
    "https://novopsych.com/wp-content/uploads/2023/03/dass-21_assessment_form.pdf",
  showTestimonialButton: false,
};

